function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSpriteBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.107,
    height: 322.577,
    viewBox: "0 0 220.107 322.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "color_sprite_bg_2",
    d: "M22177.764,16655.922c-21.516-13.969-34.094-27.48-42.678-49.928-12.8-33.467-12.766-78.963,8.365-111.5,12.09-18.621,29.174-13.639,48.307-8.65,11.086,2.883,22.855,5.773,34.744,4.072,26.746-3.832,53.727-45.742,78.375-29.736,28.754,18.672,25.23,40.672,30.352,72.27,4.434,27.375,20.389,63.859,3.961,89.158-17.094,26.324-53.535,56.936-82.115,63.605a55.881,55.881,0,0,1-12.74,1.5C22220.814,16686.715,22201.369,16671.25,22177.764,16655.922Zm108.178-275.779a12.866,12.866,0,1,1,12.492,9.773A12.894,12.894,0,0,1,22285.941,16380.143Z",
    transform: "translate(-22126.346 -16364.138)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSpriteBg2);
export default __webpack_public_path__ + "static/media/color_sprite_bg_2.11388147417e856ccadfadf3f7cf99a1.svg";
export { ForwardRef as ReactComponent };